import angular from 'angular'
const listPage = require('./view/list.html')
const inputPoolListCtrl = require('./list')
const tax3DetailPage = require('./view/tax3InvoiceDetail.html')
const tax4DetailPage = require('./view/tax4InvoiceDetail.html')
const inputDetailCtrl = require('./detailCtrl')
const synInvoicePage = require('./view/synInvoiceModal.html')
const inputSynInvoiceCtrl = require('./synInvoiceCtrl')
const synProgressPage = require('./view/synProgress.html')
const inputSynProgressCtrl = require('./synProgressCtrl')
const downloadProgressPage = require('./view/downloadProgress.html')
const inputDownloadProgressCtrl = require('./downloadProgressCtrl')
const downloadRecordCtrl = require('./downloadRecordCtrl')
const collectRecordPage = require('./view/collectRecord.html')
const collectRecordCtrl = require('./collectRecordCtrl')
const config = ($stateProvider) => {
    $stateProvider
        .state('input.invoicePool.inputInvoicePool', {
            abstract: true,
            url: '/inputInvoicePool',
            template: '<div ui-view></div>',
            default: 'input.invoicePool.inputInvoicePool.list',
        })
        .state('input.invoicePool.inputInvoicePool.list', {
            url: '/list',
            template: listPage,
            controller: 'inputPoolListCtrl',
            title: '进项发票池',
        })
        .state('input.invoicePool.inputInvoicePool.tax3Detail', {
            url: '/tax3Detail/:invoiceId/:invType',
            template: tax3DetailPage,
            controller: 'inputDetailCtrl',
            title: '发票预览',
            params: {
                detailFlag: true,
            },
        })
        .state('input.invoicePool.inputInvoicePool.tax4Detail', {
            url: '/tax4Detail/:invoiceId/:invType',
            template: tax4DetailPage,
            controller: 'inputDetailCtrl',
            title: '发票预览',
            params: {
                detailFlag: true,
            },
        })
        .state('input.invoicePool.inputInvoicePool.synInvoice', {
            url: '/synInvoice',
            template: synInvoicePage,
            controller: 'inputSynInvoiceCtrl',
            title: '发票同步',
        })
        .state('input.invoicePool.inputInvoicePool.synProgress', {
            url: '/synProgress',
            template: synProgressPage,
            controller: 'inputSynProgressCtrl',
            title: '发票同步-进度条',
        })
        .state('input.invoicePool.inputInvoicePool.downloadProgress', {
            url: '/downloadProgress',
            template: downloadProgressPage,
            controller: 'inputDownloadProgressCtrl',
            title: '发票下载-进度条',
        })
        .state('input.invoicePool.inputInvoicePool.collectRecord', {
            url: '/collectRecord/:invoiceSource',
            template: collectRecordPage,
            controller: 'collectRecordCtrl',
            title: '归集记录',
        })
}
export default angular
    .module('input.invoicePool.inputInvoicePool', [])
    .config(['$stateProvider', config])
    .controller('inputPoolListCtrl', inputPoolListCtrl.default)
    .controller('inputDetailCtrl', inputDetailCtrl.default)
    .controller('inputSynInvoiceCtrl', inputSynInvoiceCtrl.default)
    .controller('inputSynProgressCtrl', inputSynProgressCtrl.default)
    .controller('inputDownloadProgressCtrl', inputDownloadProgressCtrl.default)
    .controller('collectRecordCtrl' ,collectRecordCtrl.default)
    .controller('downloadRecordCtrl', downloadRecordCtrl.default).name



// WEBPACK FOOTER //
// ./src/app/input/invoicePool/inputInvoicePool/index.js